/*******************************************************************************
SCROLL TO ELEMENT ON PAGE LOAD
*******************************************************************************/

export default function scrollToElementOnPageLoad() {
  const $scrollToElements = $(".scroll-to-here-on-load").first();
  if ($scrollToElements.length === 0) {
    return;
  }

  $("html, body").animate({ scrollTop: $scrollToElements.offset().top }, 300);
}
